export default __webpack_public_path__ + "static/media/colorApps.6abebae1.svg";